import { useEffect } from 'react';

type Listener = <EventType>(event: EventType) => void;

const useEventListener = (eventList: string[], listener: Listener) => {
  useEffect(() => {
    eventList.forEach(event => window.addEventListener(event, listener));

    return () => eventList.forEach(event => window.removeEventListener(event, listener));
  }, [eventList, listener]);
};

export default useEventListener;
